import type { IconData } from '@stacksjs/iconify-core'

export const panoramicScreen: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M3 24c0 5.15.14 9.239.274 11.994c.091 1.85 2.205 3.069 3.979 2.538C10.454 37.574 15.858 36.5 24 36.5s13.546 1.074 16.747 2.032c1.774.53 3.888-.688 3.979-2.538C44.86 33.239 45 29.15 45 24s-.14-9.239-.274-11.994c-.091-1.85-2.205-3.069-3.979-2.538C37.546 10.426 32.142 11.5 24 11.5S10.454 10.426 7.253 9.468c-1.774-.53-3.888.689-3.979 2.538A247 247 0 0 0 3 24m14-12.5v25m14-25v25\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default panoramicScreen
